import { render, staticRenderFns } from "./PlanDiscount.vue?vue&type=template&id=3a6d87eb&scoped=true&lang=pug&"
var script = {}
import style0 from "./PlanDiscount.vue?vue&type=style&index=0&id=3a6d87eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d87eb",
  null
  
)

export default component.exports